module.exports = __webpack_public_path__ + "img/boo.acdc6a2c.png";